import React from 'react';
import { Outlet } from 'react-router';
import { Layout } from 'antd';
import styles from './AdminPanelContainer.module.scss';

const AdminPanelContainer: React.FC = () => {
  return (
    <Layout>
      <Layout className={styles.table}>
        <Outlet />
      </Layout>
    </Layout>
  );
};

export default AdminPanelContainer;
